import React from 'react';
import PropTypes from 'prop-types';
import DialogsWithIcon from '@Containers/Dialogs/DialogsWithIcon';
import { ButtonWithIcon } from '@els/els-react--button';

import './AccountErrorModal.scss';

function AccountErrorModal({ selfClose, error }) {
  return (
    <DialogsWithIcon
      size="sm"
      movable={false}
      className="react-dialogs-scrollable account-error-modal"
      headerClassName="rx-border-none"
      footerClassName="rx-border-none"
      layoutType="error"
      character="i"
      selfClose={selfClose}
      closeBtn={false}
      header={error.errorName}
      footer={
        <ButtonWithIcon
          data-e2e="account-error-modal-ok"
          type="primary"
          size="small"
          sprite="ChevronRight"
          iconRight
          onClick={selfClose}
          className="e2e-e2e-name">
          OK
        </ButtonWithIcon>
      }>
      {error.errorMessage}
    </DialogsWithIcon>
  );
}

AccountErrorModal.propTypes = {
  selfClose: PropTypes.func.isRequired,
  error: PropTypes.shape({ errorName: PropTypes.string, errorMessage: PropTypes.string }),
};

export default AccountErrorModal;
